// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ra-D","top":"styles_top__a1q_3"};